require('backbone.marionette');
require('./spinner/spinner.scss');
var Spinner = Marionette.ItemView.extend({
    template: require('./spinner/spinner.tpl'),
    className: 'tl-spinner',
    modelEvents: {
        'change:message': 'render'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                message: 'Loading'
            }
        );
        this.model = new Backbone.Model({
            message: this.options.message
        });
    },
    serializeData: function () {
        return {
            options: this.options,
            model: this.model.toJSON()
        };
    },
    setMessage: function (message) {
        this.model.set('message', message);
    },
    onRender: function () {
        this.$el.attr(
            'showing-message',
            !_.isEmpty(this.model.get('message'))
        );
    }
});
module.exports = Spinner;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/spinner.js
 ** module id = 20
 ** module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 29 30 31 33 34 35 36 37 38 40 41 44 45 47 48 49 50 54 55 56 57 58 59 60 61 62 65 66 67 68 69 70 77 78 84 115 122 123 124
 **/